/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {},
  LABEL: {
    NO_ROWS_MENTIONS: 'Sin menciones'
  },
  SENTENCE: {
    INSTAGRAM_LINK:
      'Mencionaste a Prozis en una historia de Instagram el {publishedAt}',
    NO_ROWS_MENTIONS: 'Aún no has mencionado a Prozis en tu Instagram'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
